import MicroModal from 'micromodal';

jQuery(function ($) {
  // 車両情報
    $('.vehicle-info__link-list__wrap a').on(oEventNames.end, function (event) {
      if (!bIsScrolling) {
        event.preventDefault();
        MicroModal.close('modal-vehicle-info');
        $('#modal-vehicle-info .modal-overlay').trigger('click');
      }
    });
  // ログインモーダル
  $('.open-modal-login').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-login', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
  // 業者ログイン
  $('.open-modal-company-login').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-company-login', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
  // 求職者ログイン
  $('.open-modal-jobseeker-login').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-jobseeker-login', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});
// 民間救急の求人詳細モーダル
jQuery(function ($) {
  $('.open-modal-job-offer').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-job-offer', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});
// 民間救急の求人詳細  お問い合わせモーダル
jQuery(function ($) {
  $('.open-modal-job-offer-contact').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-job-offer-contact', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});

// 求職者情報 資格証明書
jQuery(function ($) {
  for (let i = 1; i <= 3; i++) {
    $('.js-custom-file-btn-modal-'+i).on(oEventNames.end, function (event) {
      if (!bIsScrolling) {
        event.preventDefault();
        MicroModal.show('modal-file-'+i, {
          awaitCloseAnimation: true,
          disableScroll: true
        });
      }
    });
  }
});
// 検索モーダル
jQuery(function ($) {
  $('.js-search-btn').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-search-request', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});
// 予約状況・履歴 詳細
jQuery(function ($) {
  $('.js-reserve-detail').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-reserve-detail', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});

// キャンセルモーダル
jQuery(function ($) {
  $('.js-reserve-cancel').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-reserve-cancel', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});

// 予約状況・履歴 成果報告
jQuery(function ($) {
  $('.js-reserve-outcome').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-reserve-outcome', {
        awaitCloseAnimation: true,
        disableScroll: true,
        disableFocus: true,
      });
    }
  });
});

// 登録モーダル
jQuery(function ($) {
  $('.open-modal-register').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-register', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
  $('.open-modal-company-register').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-company-register', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
  $('.open-modal-sns-register').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      $('#sns').val($(this).data('sns'));
      MicroModal.show('modal-sns-register', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
// 患者LP登録・見積もり一括モーダル
  $('.open-modal-register-quote').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-register-quote', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
    $('.open-modal-manual-movie').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      function onClose() {
        $("#pause").on(oEventNames.end, function(event){
          if (!bIsScrolling) {
            event.preventDefault();
            var $playerWindow = $('#player')[0].contentWindow;
            $playerWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        });
        if($('#player').length){
          $("#pause").trigger('click');
        }
      }
      MicroModal.show('modal-manual-move', {
        awaitCloseAnimation: true,
        disableScroll: true,
        onClose: onClose
      });
    }
  });
});
// メールテンプレート選択モーダル
// jQuery(function ($) {
//   $('.open-modal-mail-template').on(oEventNames.end, function (event) {
//     if (!bIsScrolling) {
//       event.preventDefault();
//       MicroModal.show('modal-mail-template', {
//         awaitCloseAnimation: true,
//         disableScroll: true
//       });
//     }
//   });
// });
// 受付年卒選択モーダル
// jQuery(function ($) {
//   $('.open-modal-graduation_y').on(oEventNames.end, function (event) {
//     if (!bIsScrolling) {
//       event.preventDefault();
//       MicroModal.show('modal-graduation_y', {
//         awaitCloseAnimation: true,
//         disableScroll: true
//       });
//     }
//   });
// });
// メッセージ確認モーダル（オファー）
jQuery(function ($) {
  $('.open-modal-message-confirm').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      $('#form-confirm-message input[name="user_id"]').val($('#form-send-message input[name="user_id"]').val());
      $('#form-confirm-message textarea[name="body"]').val($('#form-send-message textarea[name="body"]').val());
      MicroModal.show('modal-message-confirm', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});

// メッセージ確認モーダル（学生詳細オファー）

if($('#offerTextarea').length) {
  function modal() {
    $('.open-modal-message-offer').on(oEventNames.end, function (event) {
      if (!bIsScrolling) {
        event.preventDefault();
        $('#form-confirm-message input[name="user_id"]').val($('#form-send-message input[name="user_id"]').val());
        $('#form-confirm-message textarea[name="body"]').val($('#form-send-message textarea[name="body"]').val());
        MicroModal.show('modal-message-offer', {
          awaitCloseAnimation: true,
          disableScroll: true
        });
      }
    });
  }
// テキストエリアに文字が入力されたらメッセージ内容確認ボタンクリック可能
  var btn = $('.message-btn-box.message-confirmation');
  jQuery(window).on('load', function() {
    btn.addClass('disabled');
  });
  jQuery('#offerTextarea').on('input keyup', function() {
    var btn = $('.message-btn-box.message-confirmation');
    var value = $('#offerTextarea').val();
    var str = value.replace(/\s+/g, "");
    var count = str.length;
    var textareaValue = $('#offerTextarea').val();
    var textareaStr = textareaValue.replace(/\r?\n/g, '');
    var textAreaCount = textareaStr.length;
    console.log(count);
    if(count == 0 || textAreaCount > 1000) {
      btn.addClass('disabled');
      btn.off('click');
    }else if(count > 0) {
      btn.removeClass('disabled');
      modal();
    }
  });
}
// メッセージ送信モーダル（企業とつながる）
jQuery(function ($) {
  $('.open-modal-message').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
          $('#form-message #to-name').text($(this).data('company_name'));
          $('#form-message input[name="company_id"]').val($(this).data('company_id'));
          $('#form-message input[name="offer_status"]').val($(this).data('offer_status'));
      MicroModal.show('modal-message', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});

// メッセージ確認モーダル（オファーの「ごめんなさい」ボタン）
jQuery(function ($) {
  $('.open-modal-sorry-message').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-offer-sorry', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});

// 2択モーダル（OK押下時の挙動は、各々で設定）
jQuery(function ($) {
  $(document).on(oEventNames.end, '.open-modal-confirm', function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      $('#modal-confirm .question strong').text($(this).data('confirm'));
      // モーダル表示
      MicroModal.show('modal-confirm', {
        awaitCloseAnimation: true
      });
    }
  });
});
/*
 * SNSログイン時
 */
jQuery(function ($) {
  $('#sns-register-btn').on('click', function () {
    var sSns = $('#sns-register-form #sns').val();
    var sMember_type_id = $('#sns-register-form input:radio[name="member_type_id"]:checked').val();
    $(location).attr("href", '/login/' + sSns + '?member_type_id=' + sMember_type_id);
  });
});
/*
退会
*/
$(function() {
  $('.open-modal-withdrawal').on(oEventNames.end, function (event) {
    if (!bIsScrolling) {
      event.preventDefault();
      MicroModal.show('modal-withdrawal', {
        awaitCloseAnimation: true,
        disableScroll: true
      });
    }
  });
});
/*
プロフィール画像更新モーダル
*/
$(function() {
  if ($('#modal-profile-img').length) {
    $('.open-modal-profile-img').on(oEventNames.end, function (event) {
      if (!bIsScrolling) {
        event.preventDefault();
        MicroModal.show('modal-profile-img', {
          awaitCloseAnimation: true,
          disableScroll: true
        });
      }
    });
  };
});
/*
電話依頼者への見積もり入力
*/
jQuery(function ($) {
      $('.js-input-money').blur(function(event) {
        var money = $('.js-input-money').val();
        // var tel = $('.js-input-tel-number').val();
        // if(money && tel) {
        if(money) {
          if (!bIsScrolling) {
            event.preventDefault();
            MicroModal.show('modal-phone-client', {
              awaitCloseAnimation: true,
              disableScroll: true
            });
          }
        }
    });
      $('.js-input-tel-number').blur(function(event) {
        var money = $('.js-input-money').val();
        var tel = $('.js-input-tel-number').val();
        console.log(money);
        console.log(tel);
        if(money && tel) {
          if (!bIsScrolling) {
            event.preventDefault();
            MicroModal.show('modal-phone-client', {
              awaitCloseAnimation: true,
              disableScroll: true
            });
          }
        }
    });
});
